module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-header grid-100 grid-parent grid-container",
    style: ({
      height: ((this.windowH - 100) + "px")
    })
  }, [_c('div', {
    staticClass: "tv-home-animation"
  }, [_c('figure', {
    staticClass: "tv-home-figure"
  }, [_c('div', {
    staticClass: "tv-glitch tv-1"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-1c.jpg",
      "alt": "static tv"
    }
  }), _vm._v(" "), _c('a', {
    class: _vm.tvData.tv3_colour,
    attrs: {
      "href": _vm.tvData.tv3_link,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "new-dates",
    domProps: {
      "innerHTML": _vm._s(_vm.tvData.tv3_text)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tv-glitch tv-2"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-1c.jpg",
      "alt": "static tv"
    }
  }), _vm._v(" "), _c('router-link', {
    class: _vm.tvData.tv1_colour,
    attrs: {
      "to": {
        name: 'Shows',
        params: {
          tour: _vm.tvData.tv1_slug
        }
      }
    }
  }, [_c('span', {
    staticClass: "new-dates",
    domProps: {
      "innerHTML": _vm._s(_vm.tvData.tv1_text)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "tv-glitch tv-3"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-1c.jpg",
      "alt": "static tv"
    }
  }), _vm._v(" "), _c('a', {
    class: _vm.tvData.tv2_colour,
    attrs: {
      "href": _vm.tvData.tv2_link,
      "target": "_blank"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tvData.tv2_text)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tv-glitch tv-4"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-1c.jpg",
      "alt": "static tv"
    }
  }), _vm._v(" "), _c('router-link', {
    class: _vm.tvData.tv5_colour,
    attrs: {
      "to": {
        name: 'Shows',
        params: {
          tour: _vm.tvData.tv5_slug
        }
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tvData.tv5_text)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "tv-glitch tv-5"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-1c.jpg",
      "alt": "static tv"
    }
  }), _vm._v(" "), _c('a', {
    class: _vm.tvData.tv4_colour,
    attrs: {
      "href": _vm.tvData.tv4_link,
      "target": "_blank"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.tvData.tv4_text)
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('img', {
    staticClass: "tv-background",
    attrs: {
      "src": require("../assets/images/tv-3b.png")
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-6"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-wobble.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-7"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-rgb-1.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-8"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-wobble.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-9"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-wobble.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-10"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-rgb-1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-11"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-rgb-1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-12"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-wobble.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-13"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-rgb-1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-14"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-wobble.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-15"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-wobble.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-16"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-rgb-1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tv-glitch tv-17"
  }, [_c('img', {
    attrs: {
      "src": "static/tvs/glitch-gif-rgb-1.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4b066f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TvHeader.vue
// module id = 289
// module chunks = 0